import { TableColumn } from "../table/TableColumn";

const DiscoveryColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "productName",
        sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        isNumeric: false,
        id: 1,
        sortByName: "fixedAddress",
        sortDirection: "asc",
        active: true,
        translationKey: "fixedAddress"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        isNumeric: false,
        id: 2,
        sortByName: "ipAddress",
        sortDirection: "asc",
        active: true,
        translationKey: "ipAddress"
    }
]

export default DiscoveryColumns;
